import FormGroup from "features/shared/forms/components/FormGroup";
import { getTranslatedFormText } from "features/shared/helpers/translationHelper";
import React from "react";
import { useTranslation } from "react-i18next";
import IDataFilterProps from "../IDataFilterProps";

const DataFilterCheckBox = (props: IDataFilterProps) => {
  // translations
  const tLables = useTranslation("shared\\dataFilters").t;
  
  const handleOnChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = e.target.checked;
    const name: string = e.target.name;
    let newDescriptors = [...props.descriptors];

    // Získám descriptor
    const descriptor = newDescriptors.find((x) => x.name === name);
    if (!descriptor) return;

    // Získám hodnotu z descriptoru a nastavím
    (descriptor.value as boolean) = checked;

    // Update
    props.setDescriptors(newDescriptors);
  };

  return (
    <FormGroup
      inputId={props.filterDescriptor.name}
      labelText={getTranslatedFormText(props.filterDescriptor, "label", tLables)}
      key={props.reactKey}
    >      
      <div className="custom-control custom-checkbox">
        <input
          type="checkbox"
          className="custom-control-input"
          id={props.filterDescriptor.name}
          name={props.filterDescriptor.name}
          checked={props.filterDescriptor.value}
          aria-describedby="filterInput"
          onChange={handleOnChangeCheckBox}
        />
         <label className="custom-control-label" htmlFor={props.filterDescriptor.name}>
         {getTranslatedFormText(props.filterDescriptor, "label", tLables)}
      </label>
      </div>
    </FormGroup>
  );
};

export default DataFilterCheckBox;
